module.exports = __webpack_public_path__ + "static/media/appstore.1e198345.svg";